/**
 * Get an environment variable.
 */
export function getEnv<T = string>(key: string): T | undefined {
  return import.meta.env[key];
}
